<template>
    <div class=long-comic>

        <div class=comic>

            <img v-for="image in images" :key="image.image" :src="image.image" @click="popupActive = true">

        </div>

        <div class=text-content v-html="content"></div>

        <div class=close @click="$emit('close-popup')"></div>

    </div>
</template>
<script>

export default {
    name : 'LongComic',
    props : {
        images  : Array ,
        content : String,
    },
    data() {
        return {
            popupActive : false,
        }
    },

}
</script>